import { loadRemoteModule } from '@angular-architects/module-federation';
import { AfterViewInit, Component, Inject, Renderer2 } from '@angular/core';
import {
  MatLegacyDialogRef as MatDialogRef,
  MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
} from '@angular/material/legacy-dialog';

@Component({
  selector: 'order-prospectus-wrapper',
  templateUrl: './order-prospectus-wrapper.component.html',
})
export class OrderProspectusWrapperComponent implements AfterViewInit {
  constructor(
    public dialogRef: MatDialogRef<OrderProspectusWrapperComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngAfterViewInit(): void {
    this.processPopup();
  }

  async processPopup() {
    let cdnUrl = (window as any).pershingAppSettings.elementConfig[
      'mf-order-entry-container-component'
    ]['url'];
    const mRef = await loadRemoteModule({
      type: 'module',
      remoteEntry: cdnUrl,
      exposedModule: './web-components',
    }).then((m) => console.log(m));
  }
}
